import { apiPost, apiGet } from './client';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
}

export interface AuthResponse {
  success: boolean;
  data: {
    user: any;
    accessToken: string;
    refreshToken: string;
  };
  message?: string;
}

export const authApi = {
  // User authentication
  register: (data: RegisterData): Promise<AuthResponse> => {
    return apiPost('/auth/register', data);
  },

  login: (credentials: LoginCredentials): Promise<AuthResponse> => {
    return apiPost('/auth/login', credentials);
  },

  // Admin authentication
  adminLogin: (credentials: LoginCredentials): Promise<AuthResponse> => {
    return apiPost('/auth/admin/login', credentials);
  },

  // Get current user
  getCurrentUser: (): Promise<any> => {
    return apiGet('/auth/me');
  },

  // Logout
  logout: (): Promise<any> => {
    return apiPost('/auth/logout');
  },
};




